 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod
 
 const PostCreateGreetingNotes = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.CreateGreetingNotes,
   method: RequestType.POST,
   data,
 });
  const UpdateGreetingNotes = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.UpdateGreetingNotes,
   method: RequestType.PUT,
   data,
 }); 
 
const GreetingNotesCommand = {
  PostCreateGreetingNotes,
  UpdateGreetingNotes

}

export default GreetingNotesCommand;
